import type { Asset, Category } from "../../model/asset.model";

function normalize(q: string): string {
  return q.trim().toLowerCase();
}

export function categoryMatches(category: Category, q: string): boolean {
  if (!q) return true;
  const n = normalize(q);
  return (
    category.name.toLowerCase().includes(n) ||
    category.id.toLowerCase().includes(n)
  );
}

export function assetMatches(asset: Asset, q: string): boolean {
  if (!q) return true;
  const n = normalize(q);
  return (
    asset.title.toLowerCase().includes(n) ||
    asset.tags.toLowerCase().includes(n) ||
    asset.description.toLowerCase().includes(n)
  );
}

/**
 * Returns categories to show: each row may have a subset of assets when the query
 * matches titles/tags/descriptions. If the category name/id matches, all assets stay visible.
 */
export function filterCategoriesBySearch(
  categories: Category[],
  searchQuery: string
): Category[] {
  const q = normalize(searchQuery);
  if (!q) return categories;

  return categories
    .map((cat) => {
      const wholeCategory = categoryMatches(cat, searchQuery);
      const assets = wholeCategory
        ? cat.assets
        : cat.assets.filter((a) => assetMatches(a, searchQuery));
      return { ...cat, assets };
    })
    .filter((cat) => cat.assets.length > 0);
}

/**
 * When the search string matches exactly one category (by name or id),
 * callers can use it for banner titles etc.
 */
export function findUniqueCategoryBySearchQuery(
  categories: Category[],
  searchQuery: string
): Category | null {
  const q = normalize(searchQuery);
  if (!q) return null;
  const matches = categories.filter((c) => categoryMatches(c, searchQuery));
  return matches.length === 1 ? matches[0] : null;
}
